import React, { useState } from 'react';
import { ShareLinkFieldType } from '../link-config-form.factory';
import { ToggleComponent } from 'src/common/form/toggle/component';

interface Props {
  indexing: ShareLinkFieldType<boolean>;
  onFieldChange: <T>(payload: ShareLinkFieldType<T>) => void;
}

export const ShareIndexing = ({ indexing, onFieldChange }: Props) => {
  const [isIndexingEnabled, setIsIndexingEnabled] = useState(!!indexing.value);

  const onIndexingFieldToggleChanged = (value: boolean) => {
    setIsIndexingEnabled(value);
    onFieldChange({ field: indexing.field, value: !value });
  };

  return (
    <div className='flex flex-col space-y-sm'>
      <ToggleComponent
        checked={isIndexingEnabled}
        onChange={onIndexingFieldToggleChanged}
        label='Allow indexing'
        labelType='strong'
      />
      <div className='text-bedrock-p-small text-bedrock-black'>Allow Google to index your Journey</div>
    </div>
  );
};
